/* KIRA SHIZUKU — carrinho deslizante v3
- Botões "追加する" de upsell / cross-sell / downsell (adiciona sem recarregar)
- Seletores por opção (cor / tamanho) nos cards: atualizam preço e variante
- Order bump (caixinha marca = adiciona, desmarca = remove)
- Abertura instantânea da gaveta ao clicar em "カートに追加"
- No editor do tema: clicar na seção "KS – Carrinho deslizante" abre a gaveta */
(function () {
if (window.ksCart) return;
window.ksCart = true;
var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };
var drawer = function () { return document.querySelector('cart-drawer'); };
var busyTimer;
function busy(on) {
var d = drawer();
if (!d) return;
d.classList.toggle('ks-cart-loading', !!on);
clearTimeout(busyTimer);
if (on) busyTimer = setTimeout(function () { busy(false); }, 8000);
}
// Requisição ao carrinho já pedindo o HTML da gaveta (uma única ida ao servidor)
function request(url, payload) {
var d = drawer();
if (d && typeof d.getSectionsToRender === 'function') {
payload.sections = d.getSectionsToRender().map(function (s) { return s.id; });
payload.sections_url = window.location.pathname;
}
window.__ksSkipDrawerRefresh = true;
busy(true);
return fetch(root() + url, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify(payload)
})
.then(function (r) { return r.json(); })
.then(function (data) {
if (data.status || data.errors) throw new Error(data.description || data.message || data.errors);
if (d && data.sections && typeof d.renderContents === 'function') d.renderContents(data);
else window.location.href = root() + 'cart';
if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ks-cart', cartData: data });
}
})
.catch(function (e) {
window.__ksSkipDrawerRefresh = false;
console.error('[KS cart]', e);
var box = document.getElementById('CartDrawer-CartErrors');
if (box) box.textContent = (e && e.message) || (window.cartStrings && window.cartStrings.error) || 'Error';
})
.finally(function () { busy(false); });
}
// Botões 追加する
document.addEventListener('click', function (e) {
var btn = e.target.closest && e.target.closest('[data-ks-add]');
if (!btn) return;
e.preventDefault();
if (btn.disabled) return;
var id = Number(btn.getAttribute('data-ks-add'));
if (!id) return;
btn.setAttribute('aria-busy', 'true');
request('cart/add.js', { items: [{ id: id, quantity: 1 }] }).finally(function () {
btn.removeAttribute('aria-busy');
});
});
// Card de produto: escolhe a variante a partir dos seletores (cor, tamanho...)
function syncCard(card) {
var json = card.querySelector('[data-ks-variants]');
if (!json) return;
var variants;
try { variants = JSON.parse(json.textContent); } catch (err) { return; }
var chosen = Array.prototype.map.call(card.querySelectorAll('[data-ks-opt]'), function (s) { return s.value; });
var match = variants.filter(function (v) {
return chosen.every(function (val, i) { return v.o[i] === val; });
})[0];
var btn = card.querySelector('[data-ks-add]');
var price = card.querySelector('[data-ks-price]');
var cmp = card.querySelector('[data-ks-cmp]');
if (!btn) return;
if (!match) {
btn.disabled = true;
return;
}
btn.setAttribute('data-ks-add', match.id);
btn.disabled = !match.a;
if (price) price.textContent = match.p;
if (cmp) {
if (match.c) { cmp.textContent = match.c; cmp.hidden = false; }
else cmp.hidden = true;
}
}
// Seletor de variante e order bump (captura: impede o Dawn de tratar como mudança de quantidade)
document.addEventListener('change', function (e) {
var t = e.target;
if (!t || !t.matches) return;
if (t.matches('[data-ks-opt]')) {
e.stopPropagation();
var card = t.closest('[data-ks-product]');
if (card) syncCard(card);
return;
}
if (t.matches('[data-ks-bump]')) {
e.stopPropagation();
var id = Number(t.getAttribute('data-ks-bump'));
if (!id) return;
if (t.checked) request('cart/add.js', { items: [{ id: id, quantity: 1 }] });
else request('cart/change.js', { id: String(id), quantity: 0 });
}
}, true);
// Abertura instantânea: abre a gaveta no clique, antes da resposta do servidor
document.addEventListener('submit', function (e) {
var form = e.target;
if (!form || !form.closest || !form.closest('product-form')) return;
if (form.closest('quick-add-modal')) return;
var d = drawer();
if (!d || typeof d.open !== 'function') return;
window.__ksSkipDrawerRefresh = true;
busy(true);
d.open();
});
if (window.customElements) {
// Tira o carregamento assim que o conteúdo novo é desenhado
customElements.whenDefined('cart-drawer').then(function () {
var C = customElements.get('cart-drawer');
var p = C && C.prototype;
if (!p || p.__ks) return;
p.__ks = true;
var orig = p.renderContents;
p.renderContents = function () {
var r = orig.apply(this, arguments);
this.classList.remove('ks-cart-loading');
return r;
};
});
// Evita a segunda requisição que o Dawn faz depois de adicionar (a gaveta já veio pronta)
customElements.whenDefined('cart-drawer-items').then(function () {
var C = customElements.get('cart-drawer-items');
var p = C && C.prototype;
if (!p || p.__ks) return;
p.__ks = true;
var orig = p.onCartUpdate;
p.onCartUpdate = function () {
if (window.__ksSkipDrawerRefresh) {
window.__ksSkipDrawerRefresh = false;
return Promise.resolve();
}
return orig.apply(this, arguments);
};
});
}
// Erro ao adicionar (ex.: esgotado): fecha a gaveta para a mensagem do produto aparecer
if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
subscribe(PUB_SUB_EVENTS.cartError, function () {
window.__ksSkipDrawerRefresh = false;
busy(false);
var d = drawer();
if (d && d.classList.contains('active')) d.close();
});
}
// Editor do tema: selecionar a seção ou um bloco abre a gaveta
function inCart(el) { return el && (el.id === 'shopify-section-cart-drawer' || (el.closest && el.closest('#shopify-section-cart-drawer'))); }
document.addEventListener('shopify:section:select', function (e) { if (inCart(e.target)) { var d = drawer(); d && d.open(); } });
document.addEventListener('shopify:block:select', function (e) { if (inCart(e.target)) { var d = drawer(); d && d.open(); } });
document.addEventListener('shopify:section:deselect', function (e) { if (inCart(e.target)) { var d = drawer(); d && d.close(); } });
})();
